import { useSelector } from "react-redux";

import { Box, Logo } from "@seneca/senekit";
import { LogoVariant } from "@seneca/senekit/out/components/content/Logo/consts";

import { getAppName, useIsPlurallApp } from "features/plurall";
import { getRegion } from "features/regions/selectors";

import { getAppVersion } from "../utils/functions/app";

export default function ParentLogo() {
  const isPlurallApp = useIsPlurallApp();
  const region = useSelector(getRegion);

  const title = `${getAppName()} ${getAppVersion()}`;

  const { variant, text } = REGION_VARIANTS[region!] ?? REGION_VARIANTS["GB"];

  return (
    <Box title={title}>
      <Logo
        variant={isPlurallApp ? "plurall" : variant}
        text={isPlurallApp ? undefined : text}
        height={["36px", "40px"]}
        width="auto"
        textSize="small"
      />
    </Box>
  );
}

const REGION_VARIANTS: {
  [key: string]: { variant: LogoVariant; text: string | undefined };
} = {
  BR: {
    variant: "goStudent",
    text: "PAIS E MÃES"
  },
  FR: {
    variant: "goStudent",
    text: "LES PARENTS"
  },
  MX: {
    variant: "goStudent",
    text: "PADRES Y MADRES"
  },
  CO: {
    variant: "goStudent",
    text: "PADRES Y MADRES"
  },
  GB: {
    variant: "goStudent",
    text: "FOR PARENTS"
  },
  DE: {
    variant: "goStudent",
    text: "FÜR ELTERN"
  },
  AT: {
    variant: "goStudent",
    text: "FÜR ELTERN"
  }
};
